import React from "react";
import {Button, Empty, Popconfirm, Tooltip} from "antd";
import {useTranslation} from "react-i18next";
import {TableContainer, ActionButtons} from "./ResponsiveDataTable.styles";
import {useStore} from "../../../../hooks/useStore";
import {CheckOutlined} from "@ant-design/icons";
import moment from "moment";
import {EmptyMessage} from "../../../_defaultComponents/EmptyMessage/EmptyMessage";

const TABLE_PREFIX = "poolTable";
const ResponsiveDataTable = ({data, loading, currentPage, setCurrentPage, dataCount, recall}) => {
    const {t} = useTranslation(["pools"]);
    const stores = useStore();

    const handleApprove = async ({poolShiftId}) => {
        try {
            const response = await stores.poolShiftStore.approveCancelRequest({poolShiftId});
            if (response) {
                recall();
            }
        } catch (e) {}
    };
    const renderActionButtons = (id, cancelRequest) => {
        const permisions = {
            approve: !stores.meStore.checkRole("isCustomer")
        };
        const isCanceled = cancelRequest?.status !== "cancel_requested";

        return (
            <ActionButtons>
                {permisions.approve && (
                    <>
                        <Tooltip title={isCanceled ? "Onaylandığı için işlem yapılamaz" : "Onayla"}>
                            <Popconfirm
                                title={"İptal talebi onaylanacak, emin misiniz?"}
                                onConfirm={() => handleApprove({poolShiftId: id})}
                                okText="Evet"
                                cancelText="Hayır"
                                disabled={isCanceled}
                            >
                                <Button disabled={isCanceled} icon={<CheckOutlined />} />
                            </Popconfirm>
                        </Tooltip>
                    </>
                )}
            </ActionButtons>
        );
    };

    return (
        <>
            <TableContainer
                className={TABLE_PREFIX}
                pagination={{
                    total: dataCount,
                    current: currentPage,
                    onChange: async page => {
                        setCurrentPage(page);
                    },
                    hideOnSinglePage: true,
                    showSizeChanger: false
                }}
                rowKey="_id"
                rowClassName="hello"
                dataSource={data}
                data-testid="poolDataTable"
                loading={loading}
                locale={{
                    emptyText: <EmptyMessage />
                }}
            >
                <TableContainer.Column
                    dataIndex="date"
                    title={"Tarih"}
                    render={date => (
                        <span data-testid="date" data-label={`Date:`}>
                            {date}
                        </span>
                    )}
                />
                <TableContainer.Column
                    dataIndex="shiftHour"
                    title={"Vardiya"}
                    render={shiftHour => (
                        <span data-testid="shiftHour" data-label={`Vardiya:`}>
                            {shiftHour?.startTime} - {shiftHour?.endTime}
                        </span>
                    )}
                />
                <TableContainer.Column
                    dataIndex="courier"
                    title={"Kurye"}
                    render={courier => (
                        <span data-testid="courier" data-label={`Kurye:`}>
                            {courier?.fullname}
                        </span>
                    )}
                />
                <TableContainer.Column
                    dataIndex="cancelReason"
                    title={"İptal Nedeni"}
                    render={cancelReason => (
                        <span data-testid="cancelReason" data-label={`İptal Nedeni:`}>
                            {cancelReason?.name}
                        </span>
                    )}
                />
                <TableContainer.Column
                    dataIndex="cancelNote"
                    title={"Not"}
                    render={cancelNote => (
                        <span
                            data-testid="cancelNote"
                            data-label={`Not:`}
                            style={{maxWidth: "200px"}}
                        >
                            {cancelNote}
                        </span>
                    )}
                />
                <TableContainer.Column
                    dataIndex="createdAt"
                    title={"Oluşturulma Tarihi"}
                    render={cancelReason => (
                        <span data-testid="createdAt" data-label={`Oluşturulma Tarihi:`}>
                            {moment(cancelReason?.createdAt).format("DD.MM.YYYY HH:mm")}
                        </span>
                    )}
                />

                <TableContainer.Column
                    align="right"
                    title={t("actions.action", {ns: "common"})}
                    dataIndex="_id"
                    render={renderActionButtons}
                />
            </TableContainer>
        </>
    );
};

export default ResponsiveDataTable;
